<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Дополнительный доход</h1>

                <div class="form-wrap__row">
                    <c-radio-group v-model="haveAdditionalIncome" :valueList="haveAdditionalIncomeList" :label="additionalIncomeBoolLabel"
                                   :fieldName="'haveAdditionalIncome'"
                                   v-on:change="selectAdditionalIncome"></c-radio-group>
                </div>


                <div class="form-wrap__row" v-if="haveAdditionalIncome">
                    <c-input
                            :label="'Сумма дополнительного дохода'"
                            :type="'tel'"
                            :fieldName="'additionalIncome'"
                            :validation="'decimal'"

                            :externalStatus="additionalIncomeExternalStatus"
                            v-model="additionalIncome"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>


                <div class="form-wrap__row" v-if="additionalIncomeFilled">
                    <p class="form-wrap__text-info"></p>
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'RelativeContacts'}"
                                     @click.native="save(['additionalIncome'])"
                                     tag="button" class="form-button form-button--yellow form-button--long-text">
                            Продолжить
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {createHelpers} from 'vuex-map-fields';
    import store from '@/storage/index'
    import {GET_PROFILE} from "@/storage/mutations";
    import {TOGGLE_LOADER} from "@/storage/mutations";
    import {STATUSES} from "@/components/statuses";
    import registrationMixins from '@/modules/mixins/registrationMixins'

    const {mapFields} = createHelpers({
        getterType: 'profile/getField',
        mutationType: 'profile/updateField',
    });

    export default {
        name: 'AdditionalIncome',
        mixins: [registrationMixins],
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {
                haveAdditionalIncome: '',
                haveAdditionalIncomeList:[
                    {
                        label: 'Да',
                        value: true,
                    },
                    {
                        label: 'Нет',
                        value: false,
                    }
                ]
            }
        },
        watch: {
            additionalIncome:{
                immediate: true,
                handler (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        this.additionalIncome = newVal.toString().replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    }
                }
            }

        },
        methods: {
            selectAdditionalIncome: function () {
                if(!this.haveAdditionalIncome){
                    this.$router.push({name: 'RelativeContacts'});
                }
            }
        },
        asyncComputed: {},
        computed: {
            additionalIncomeBoolLabel: function () {
              return this.haveAdditionalIncome === '' ?  'У вас есть дополнительный доход?'  : 'Дополнительный доход';
            },
            additionalIncomeFilled: function () {
              return this.additionalIncome.length > 5 && this.haveAdditionalIncome !== '';
            },
            ...mapFields([
                'additionalIncome',
                'additionalIncomeExternalStatus',
                'additionalIncomeExternalError',
            ]),
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 50, nextPercent: 10});
        }
    }
</script>

<style lang="scss">

</style>